import React from 'react'
import { cssClass } from '../../../shared/utils/styles'
import { card } from './styles/styles.css'
import { vars } from '../../../styles/v2/vars.css'

interface Props {
  children: React.ReactNode
  className?: string[]
  background?: string
  overflow?: boolean
}

export const CardComponent: React.FC<Props> = ({
  background,
  children,
  overflow = false,
  className = [''],
}) => {
  const backgroundColor = background ? background : vars.background.primary
  const overflowStyle = overflow ? { overflow: 'hidden' } : {}
  return (
    <div style={{ backgroundColor, ...overflowStyle }} className={cssClass([card, ...className])}>
      {children}
    </div>
  )
}
